import { Box, Typography } from "@mui/material";
import TkSelectForm from "../../../components/atoms/TkSelectForm";
import { TkGetCodeList } from "../../../utils/TkGetCode";
import {
  ProcedureKiko,
  Status,
  submitWay,
} from "../../../assets/data/Constants";
import TkPrefecturesPick from "../../../components/molecules/TkPrefecturesPick";
import TkLabelText from "../../../components/atoms/TkLabelText";
import TkDatePicker from "../../../components/atoms/TkDatePicker";
import TkButton from "../../../components/atoms/TkButton";
import { useState } from "react";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";
import { ISearchForHomeProps } from "../../../type/contextType/businessContext/ISearchForHome";

interface KikoHomeSearchFormProps {
  managerList: any;
  defaultValue?: ISearchForHomeProps;
  showResult?: boolean;
  resultNum?: number;
  onSearch: (e: any) => void;
}

const KikoHomeSearchForm: React.FC<KikoHomeSearchFormProps> = ({
  managerList,
  defaultValue,
  showResult = false,
  resultNum,
  onSearch,
}) => {
  const [errorMsg, setErrorMsg] = useState<any>({});
  const [dateError, setDateError] = useState({});
  const [formValues, setFormValues] = useState({});

  const handleOnChange = (field: any) => (event: any) => {
    if (field === "contractorNo" && !event.target.value.match(/^(\d{6})?$/)) {
      setErrorMsg({
        ...errorMsg,
        contractorNo: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
      });
    } else {
      setErrorMsg({
        ...errorMsg,
        contractorNo: "",
      });
    }

    const formValue =
      field === "prefectureList"
        ? event.map((i: any) => ({ prefecture: i }))
        : event.target.value;
    setFormValues((tempFormValues: any) => {
      const tempValues = { ...tempFormValues };
      if (formValue) {
        return { ...tempValues, [field]: formValue };
      } else {
        const { [field]: _, ...rest } = tempValues;
        return rest;
      }
    });
  };

  const handleSearch = () => {
    if (
      Object.values(errorMsg).some((item) => item) ||
      Object.values(dateError).some((item) => item)
    ) {
      return;
    }

    onSearch(formValues);
  };

  return (
    <Box className="SCRW110001">
      <Box className="searchForm">
        <Box className="flexBox">
          <TkSelectForm
            onChange={handleOnChange("status")}
            label="ステータス"
            selectPropsList={TkGetCodeList(Status)}
            wantToSetValue={defaultValue?.status}
          />

          <TkSelectForm
            onChange={handleOnChange("businessType")}
            label="申請・届出（手続き）"
            minW="200px"
            selectPropsList={TkGetCodeList(ProcedureKiko)}
            wantToSetValue={defaultValue?.businessType}
          />
          <TkPrefecturesPick
            onSuccessful={handleOnChange("prefectureList")}
            wantToSetValue={defaultValue?.prefectureList?.map(
              (i) => i.prefecture
            )}
          />
        </Box>

        <Box className="flexBox">
          <TkSelectForm
            onChange={handleOnChange("manager")}
            label="担当者"
            selectPropsList={managerList}
            wantToSetValue={defaultValue?.manager}
          />

          <TkLabelText
            onChange={handleOnChange("contractorNo")}
            label="共済契約者番号"
            variant="standard"
            inputProps={{ maxLength: 6 }}
            onlyNumber
            wantToSetValue={defaultValue?.contractorNo}
            error={!!errorMsg.contractorNo}
            helperText={errorMsg.contractorNo}
          />

          <TkSelectForm
            onChange={handleOnChange("corpApplyKbn")}
            label="提出方式"
            selectPropsList={TkGetCodeList(submitWay)}
            wantToSetValue={defaultValue?.corpApplyKbn}
          />

          <Typography>申請年月日：</Typography>
          <TkDatePicker
            onChange={handleOnChange("applyStartDate")}
            minDate={new Date("1900/01/01")}
            maxDate={new Date("2099/12/31")}
            wantToSetValue={defaultValue?.applyStartDate}
            onGetErrorFlg={(e: any) =>
              setDateError({ ...dateError, applyStartDate: e })
            }
          />
          <Box> ～ </Box>
          <TkDatePicker
            onChange={handleOnChange("applyEndDate")}
            minDate={new Date("1900/01/01")}
            maxDate={new Date("2099/12/31")}
            wantToSetValue={defaultValue?.applyEndDate}
            onGetErrorFlg={(e: any) =>
              setDateError({ ...dateError, applyEndDate: e })
            }
          />

          <TkButton onClick={handleSearch}>検索</TkButton>

          <Typography
            className={showResult ? "seleteTitle" : "seleteTitle nothing"}
          >
            検索結果：{resultNum}件
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default KikoHomeSearchForm;
